import React from 'react';
import {Link} from "react-router-dom";
import {Slang} from "../../../helpers";

const CompanyMenu = () => {
    const menu1 = Slang('dashboard.menu.m1');
    return (
        <div id="dashboardSidebar" className="nav-collapse collapse ">
            <a className="nav-link dropdown-toggle"
               href="#companyMenu" role="button"
               data-bs-toggle="collapse"
               aria-expanded="false"
               aria-controls="companyMenu">{menu1('m12.title')}</a>

            <div id="companyMenu" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u1.m121')}</Link>
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u1.m122')}</Link>
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u1.m123')}</Link>
            </div>
        </div>
    );
};

export default CompanyMenu;